<template>
    <div class="welcome">
        <div class="header">
            <div class="inner">
                <div
                    :style="{background: VUE_APP_ENV === 'prod' ? '' : '#409EFF'}"
                    class="logo-wrap"
                >
                    <img
                        class="logo"
                        src="../../assets/welcome/logo@2x.png"
                    >
                </div>
                <div class="header-right">
                    <slot name="header-right" />
                </div>
            </div>
        </div>
        <div class="main">
            <div class="inner">
                <slot />
            </div>
        </div>

        <slot name="base-footer" />
    </div>
</template>

<script>
export default {
    name: 'BaseLayout',
    components: {
    },
    data() {
        return {
            VUE_APP_ENV: window.XCConfig.VUE_APP_ENV,
        };
    },
    methods: {
        onClickLogout() {
            this.$router.push({
                name: 'login',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.welcome {
  position: relative;
  min-height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: url('../../assets/welcome/bg2.jpg');
  background-color: #f0f4fa;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1200px 690px;
}

.inner {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.header {
  height: 96px;
}

.logo-wrap {
  width: 180px;
  height: 68px;
  overflow: hidden;
  background: #ce2b21;
  display: flex;
  align-items: center;
  justify-content: center;

  .logo {
    width: 130px;
  }
}

.header-right {
  flex: 1;
  color: #999;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
